import PropTypes from 'prop-types';
import React from 'react';
import { withApplicationContext } from '../../utils/ApplicationContext';
import { withLabels } from '../../utils/LabelsContext';
import Popover from '../ui/Popover/Popover';
import { cookiesPopoverStyles } from './CookiesPopover.style';
import { useCookiesPopover } from './useCookiesPopover';

const notAllowedDevices = ['desktop'];

const CookiesPopover = ({ labels, appCtx }) => {
  const { store, regionCode } = appCtx;
  const { setVisible, visible, acceptCookie } = useCookiesPopover({
    regionCode,
    store,
  });
  if (notAllowedDevices.includes(appCtx.deviceType)) {
    return null;
  }
  return (
    <Popover
      trigger="none"
      fullWidth
      content={() => (
        <div className="container" data-testid="cookie-legal-modal">
          <div>
            <div className="first-line">
              <span>{labels.CHECK_PRIVACITY || 'Revisa nuestras'}</span>{' '}
              <span className="underlined-link">{labels.PRIVACY_POLICIES || 'políticas de privacidad'}</span>{' '}
              <span>{labels.AND || 'y'}</span> <span>{labels.OF || 'de'}</span>{' '}
              <span className="underlined-link">{labels.COOKIES || 'cookies'}</span>
            </div>
            <button data-testid="cookie-legal-modal-button" type="button" className="bold" onClick={acceptCookie}>
              <i className="csicon-mkp-succes" />{' '}
              <span className="underlined-link">{labels.ACCEPT_COOKIES || 'Aceptar cookies'}</span>
            </button>
          </div>

          <button type="button" className="close-button" onClick={acceptCookie}>
            <i className="csicon-danger">
              <span className="sr-only">{labels.CLEAR}</span>
            </i>
          </button>
          <style jsx>{cookiesPopoverStyles}</style>
        </div>
      )}
      type="compact"
      position="center"
      dismissOnOutsideClick={false}
      transparent
      toggleState={{
        setVisible,
        visible,
      }}
      sticky
    />
  );
};

CookiesPopover.propTypes = {
  labels: PropTypes.object.isRequired,
  appCtx: PropTypes.object.isRequired,
};

export default withApplicationContext(withLabels(CookiesPopover));
export { CookiesPopover };
